import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "ownerPolicy", "explicitPerson", "explicitTeam"]

  connect() {
    this.update()
  }

  update() {
    this.updateOwnerOptions()
    this.updateExplicitOwners()
  }

  updateOwnerOptions() {
    const mode = this.modeTarget.value
    const allowed = this.allowedPoliciesFor(mode)
    let selectedOptionAllowed = false

    Array.from(this.ownerPolicyTarget.options).forEach((option) => {
      const visible = option.value === "" || allowed.includes(option.value)
      option.hidden = !visible
      option.disabled = !visible
      if (visible && option.selected) selectedOptionAllowed = true
    })

    if (!selectedOptionAllowed) {
      this.ownerPolicyTarget.value = ""
    }
  }

  updateExplicitOwners() {
    this.toggle(this.explicitPersonTarget, this.ownerPolicyTarget.value === "explicit_person")
    this.toggle(this.explicitTeamTarget, this.ownerPolicyTarget.value === "explicit_team")
  }

  allowedPoliciesFor(mode) {
    const common = ["explicit_person", "explicit_team", "admin_triage"]

    switch (mode) {
      case "company":
        return ["leadership", ...common]
      case "selected_teams":
        return ["team_manager", ...common]
      case "selected_work_streams":
      case "all_work_streams":
        return ["work_stream_owner", ...common]
      default:
        return common
    }
  }

  toggle(element, visible) {
    element.classList.toggle("hidden", !visible)
    element.hidden = !visible
  }
}
